/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Export_Filename_PrefixInputs */

const en_orders_export_filename_prefix = /** @type {(inputs: Orders_Export_Filename_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`logistics-orders`)
};

const es_orders_export_filename_prefix = /** @type {(inputs: Orders_Export_Filename_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pedidos-logistica`)
};

/**
* | output |
* | --- |
* | "logistics-orders" |
*
* @param {Orders_Export_Filename_PrefixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_export_filename_prefix = /** @type {((inputs?: Orders_Export_Filename_PrefixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Export_Filename_PrefixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_export_filename_prefix(inputs)
	return es_orders_export_filename_prefix(inputs)
});